import React, {Component} from 'react'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {Row, Col} from 'reactstrap'
import LoadingButton from "../LoadingButton"
import moment from 'moment'
import PropTypes from 'prop-types'

import AUSelectGenerator from '../../components/auto_updaters/ValidSelect'

const AUSelectUserRoles = AUSelectGenerator('user_roles', 'user_role_id description', 'user_role_id', ['description'])

export class UserRoleHistoryInput extends Component {

    constructor(props) {
        super(props)

        this.state = {
            id: props.id || null,
            user_role_id: props.user_role_id || '',
            active_from: props.active_from || ''

        }
    }

    render() {

        const {onCancel, onSave, loading} = this.props
        const {id, user_role_id, active_from} = this.state
        const formattedActiveFrom = moment(active_from).format('YYYY-MM-DD')

        return (
            <AvForm
                ref={ref => this.form = ref}
                onValidSubmit={() => {
                    if (onSave) onSave(this.state)
                }}
            >
                <Row form>
                    <Col sm="6">
                        <AUSelectUserRoles
                            required
                            label="User Role*"
                            name="user_role_id"
                            bsSize="sm"
                            value={user_role_id}
                            onChange={(value) => {
                                const user_role_id = value
                                this.setState({user_role_id})
                            }}
                        />
                    </Col>
                    <Col sm="5">
                        <AvField
                            required
                            label="Active From Date*"
                            name="active_from"
                            type="date"
                            bsSize="sm"
                            placeholder="Active From"
                            value={formattedActiveFrom}
                            onChange={(evt) => this.setState({active_from: evt.target.value})}
                        />
                    </Col>
                    <Col sm="1">
                        <div className="d-flex flex-row justify-content-end align-items-center pt-4">
                            <LoadingButton
                                size="sm"
                                color="secondary"
                                className="square-btn mr-1"
                                icon="times"
                                loading={false}
                                onClick={() => {
                                    if (onCancel) onCancel()
                                }}
                            />
                            <LoadingButton
                                size="sm"
                                color="success"
                                className="square-btn"
                                icon="save"
                                loading={loading}
                            />
                        </div>
                    </Col>

                </Row>
            </AvForm>
        )
    }

}

UserRoleHistoryInput.propTypes = {
    id: PropTypes.number,
    user_role_id: PropTypes.number,
    active_from: PropTypes.string,
    onCancel: PropTypes.func,
    onSave: PropTypes.func
}